import { Grid, RegularBreakpoints } from '@mui/material';
import { ReactNode } from 'react';

export type TimesheetHeaderItemProps = {
	children: ReactNode;
	justifyContent?: Record<
		Extract<NonNullable<keyof RegularBreakpoints>, 'xs' | 'sm' | 'md'>,
		'flex-start' | 'center' | 'flex-end'
	>;
	breakpoints?: RegularBreakpoints;
};

export const TimesheetHeaderItem = ({
	children,
	justifyContent,
	breakpoints,
}: TimesheetHeaderItemProps): JSX.Element => {
	return (
		<Grid
			item
			container
			md={4}
			sm={4}
			xs={12}
			{...breakpoints}
			alignContent="flex-start"
			justifyContent={justifyContent}>
			{children}
		</Grid>
	);
};
